import { Component, Input } from "@angular/core";

@Component({
    selector: "pagination",
    template: `
    <a class="btn hilight" [class.hidden]="!(show && currentItems > 0 && currentItems !== totalItems)">
        Viewing {{currentItems}} out of {{totalItems}} | Expand More <span [innerHtml]="'arrow-down' | feather"></span>
    </a>
    `
})
export class PaginationComponent {
    @Input()
    currentItems: number;

    @Input()
    totalItems: number;

    @Input()
    show: boolean;
}